import { Menu } from "@mantine/core";
import {
  Icon2fa,
  IconAlignCenter,
  IconCircle,
  IconEye,
  IconLogout,
  IconPlugConnected,
  IconUser,
} from "@tabler/icons-react";
import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { useSession } from "../../../../../../../api/useSession";
import { useAuth } from "../../../../../../../AuthContext";
import { useIsAdminUser } from "../../../../../../../helpers/server.helpers";
import { USERS_PATH } from "../../../../../../../routes";
import AdminOnly from "../../../../../AdminOnly/AdminOnly";
import AdminMenu from "./components/AdminMenu/AdminMenu";
import ProfileLink from "./components/ProfileLink/ProfileLink";

function Dropdown() {
  const { t } = useTranslation();
  const { user, logout } = useAuth();
  const { data: session } = useSession();
  const isAdmin = useIsAdminUser();
  const iconProps = {
    width: 14,
    color: "var(--mantine-color-bluegray-0)",
    strokeWidth: 1.5,
  };
  return (
    <>
      <ProfileLink />
      <Menu.Item
        component={Link}
        to={`${USERS_PATH}/${user?.ID}/courses`}
        leftSection={<IconEye {...iconProps} />}
      >
        {t("common.listTitles.courses")}
      </Menu.Item>
      <Menu.Item
        component={Link}
        to={`${USERS_PATH}/${user?.ID}/driving-record`}
        leftSection={<IconAlignCenter {...iconProps} />}
      >
        {t("user.subMenu.drivingRecord")}
      </Menu.Item>
      <Menu.Item
        component={Link}
        to={`${USERS_PATH}/${user?.ID}/tachograph`}
        leftSection={<IconCircle {...iconProps} />}
      >
        {t("user.subMenu.tachograph")}
      </Menu.Item>
      <Menu.Item
        component={Link}
        to={`${USERS_PATH}/${user?.ID}/profile`}
        leftSection={<IconUser {...iconProps} />}
      >
        {t("user.subMenu.profileDetails")}
      </Menu.Item>
      <Menu.Label>{t("common.misc.other")}</Menu.Label>
      {(session?.User.ViewConfig.IntegrationsEnabled || isAdmin) && (
        <Menu.Item
          component={Link}
          to="/settings/integrations"
          leftSection={<IconPlugConnected {...iconProps} />}
          data-inactive={!session?.User.ViewConfig.IntegrationsEnabled}
        >
          Integrationer
        </Menu.Item>
      )}
      <AdminOnly>
        <Menu.Sub
          closeDelay={800}
          middlewares={{
            shift: { crossAxis: false },
            flip: true,
            size: { padding: 8 },
          }}
        >
          <Menu.Sub.Target>
            <Menu.Sub.Item leftSection={<Icon2fa {...iconProps} />}>
              Admin
            </Menu.Sub.Item>
          </Menu.Sub.Target>
          <AdminMenu />
        </Menu.Sub>
      </AdminOnly>
      <Menu.Item leftSection={<IconLogout {...iconProps} />} onClick={logout}>
        {t("common.buttons.logOut")}
      </Menu.Item>
    </>
  );
}

export default Dropdown;
